import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import {IModalCategoryProps, IResCategoryCreate} from '../leadSourceTypes'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {Form, Spinner} from 'react-bootstrap'
import {useEffect} from 'react'
import {parseId} from '../../../helpers'
import {useMutation} from '@apollo/client'
import {ADD_EDIT_CATEGORY} from '../../../gql/mutations/leadSourceMutations'
import {toast} from 'react-toastify'

const validationSchema = Yup.object({
  name: Yup.string().required('Name is required'),
  id: Yup.string(),
})

export const ModalAddEditCategory: React.FC<IModalCategoryProps> = ({
  isOpen,
  onClose,
  refetch,
  info,
}) => {
  const [gqlCreate, {data, loading, error}] = useMutation<IResCategoryCreate>(ADD_EDIT_CATEGORY)

  const formik = useFormik({
    initialValues: {
      name: '',
      id: '',
    },
    validationSchema,
    onSubmit: (values) => {
      const input: {name: string; id?: string} = {
        name: values.name,
      }
      if (values.id) {
        input.id = values.id
      }
      gqlCreate({
        variables: {
          input,
        },
      })
    },
  })

  useEffect(() => {
    if (info?.id && info?.name) {
      formik.setFieldValue('name', info.name)
      formik.setFieldValue('id', parseId(info.id))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [info])

  useEffect(() => {
    if (error) toast.error(`Error: ${error.message}`)
  }, [error])

  useEffect(() => {
    if (!data) return
    if (data.categoryLeadSourceCreateupdateMutation?.categoryLeadSource?.id) {
      toast.success(`Category ${info?.id ? 'edited' : 'created'} successfully`)
      onClose()
      refetch()
    } else if (
      data.categoryLeadSourceCreateupdateMutation?.errors &&
      data.categoryLeadSourceCreateupdateMutation?.errors?.length > 0
    ) {
      toast.error(
        `Error: ${
          data.categoryLeadSourceCreateupdateMutation.errors?.[0]?.messages?.[0] ||
          'Something happened'
        }`
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{info?.id ? 'Edit Category' : 'Add Category'}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={formik.handleSubmit}>
        <Modal.Body>
          <div>
            <Form.Label htmlFor='name'>Category Name</Form.Label>
            <Form.Control
              id='name'
              aria-describedby='name'
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              isInvalid={Boolean(formik.errors.name && formik.touched.name)}
              placeholder='Enter category name'
            />
            {formik.errors.name && formik.touched.name && (
              <Form.Text id='error-name' className='text-danger'>
                {formik.errors.name}
              </Form.Text>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button type='button' variant='secondary' onClick={onClose}>
            Cancel
          </Button>
          <Button type='submit' variant='primary' disabled={loading}>
            {loading && <Spinner size='sm' animation='border' className='me-2' />}
            Save Changes
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}
